module.exports = __webpack_public_path__ + "img/login.518e08bf.jpg";